import { render, staticRenderFns } from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=template&id=c19adcd2&scoped=true"
import script from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=script&lang=js"
export * from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=script&lang=js"
import style0 from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=style&index=0&id=c19adcd2&prod&scoped=true&lang=css"
import style1 from "./xinjiangUnionPayNosenseConfigure.vue?vue&type=style&index=1&id=c19adcd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19adcd2",
  null
  
)

export default component.exports